<template>
    <div :class="sidebarClasses"
        :data-background-color="backgroundColor"
        :data-active-color="activeColor">
      <div class="logo">
        <router-link class="logo-mini" to="/dashboard/overview">
          <div class="logo-img">
            <img src="static/img/pf-icon.png" alt="">
          </div>
        </router-link>
        <router-link class="logo-normal hidden-sm hidden-xs" to="/dashboard/overview">
            <img src="static/img/pf-logo-text.png" alt="" style="margin-left: 3px">
        </router-link>
        <router-link class="logo-normal img-responsive visible-sm visible-xs" to="/dashboard/overview" style="margin-left: 0px;">
            <img src="static/img/pf-logo.png" alt="">
        </router-link>
      </div>
      <div class="sidebar-wrapper" ref="sidebarScrollArea">
        <p class="text-center" style="color: #CCC" v-if="($store.state.userData && (!$route.path.includes('management') || ($route.path.includes('documents') && $store.state.managerData)))">User ID: {{ $store.state.userData.emailSettings.LoginId || 'Unassigned' }}</p>
        <ul :class="navClasses + ' user'">
          <sidebar-item v-for="(link, index) in userLinks"
                        :key="link.name + index"
                        :link="link"
                        v-if="(!link.managerOnly || ((!$route.path.includes('management') && $store.state.managerData && $store.state.userData))) && !(link.path.includes('settings') && $store.state.managerData &&  $store.state.userData && ($store.state.managerData.GroupId !== 0 || !$store.state.userData.emailSettings.hasOwnProperty('LoginId')) )">
          </sidebar-item>
          <li @click="signOut" style="cursor: pointer">
            <a>
              <i class="fa fa-sign-out"></i>
              <p>Sign Out</p>
            </a>
          </li>
        </ul>
        <p class="text-center" style="color: #CCC" v-if="$store.state.userData && !$route.path.includes('management')">{{ $store.state.userData.clientData.TrustName }}</p>
        <p class="text-center" style="color: #CCC" v-if="$store.state.managerData && !$store.state.userData && ($route.path.includes('management')||$route.path.includes('documents')) && $store.state.managerData.GroupId !== 0">{{ $store.state.managerData.groups[0].TrustName }}</p>
        <ul :class="navClasses">
          <slot name="links">
            <sidebar-item v-for="(link, index) in sidebarLinks"
                          :key="link.name + index"
                          :link="link"
                          v-if="!(link.PFTC === false && $store.state.managerData.GroupId === 0) && (typeof link.role == 'undefined' || ($store.state.managerData.Role == 'Admin' && ($store.state.managerData && ($store.state.managerData.GroupId === 0 || !link.PFTCOnly))))">

              <sidebar-item v-for="(subLink, index) in link.children"
                            :key="subLink.name + index"
                            :link="subLink">
              </sidebar-item>
            </sidebar-item>
          </slot>

        </ul>
      </div>
    </div>
</template>
<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      },
      userLinks () {
        return [
          {
            name: 'Profile Settings',
            icon: 'ti-settings',
            path: !this.$route.path.includes('management') ? '/dashboard/settings' : '/management/settings'
          },
          {
            name: 'Return to Management',
            icon: 'fa fa fa-gavel',
            path: this.$store.state.managerData && this.$store.state.managerData.GroupId !== 0 ? '/management/trustoverview' : '/management/accountview',
            managerOnly: true
          }

        ]
      }
    },
    methods: {
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      },
      signOut () {
        this.$http.post(!this.$store.state.managerData ? '/client/logout' : '/manager/logout')
        .then(response => {
          if (response.data.logout) {
            if (this.$store.state.managerData) {
              this.$store.state.managerData = null
              this.$store.state.userData = null
              this.$router.push('/managementLogin')
            } else {
              this.$store.state.userData = null
              this.$router.push('/')
            }
          }
        })
      },
      resizeResponse () {
        if (document.documentElement.clientWidth < 1250 && !this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize()
        }
        if (document.documentElement.clientWidth >= 1250 && this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize()
        }
      }
    },
    mounted () {
      this.initScrollBarAsync()
      window.addEventListener('resize', this.resizeResponse)
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
      window.removeEventListener('resize', this.resizeResponse)
    }
  }

</script>
<style>
a.active.userLink>div.user>div.info>a, a.active.userLink>div.user>div.info>a>div.photo {
  color: #7AC29A;
}

.sidebar .user {
  margin-top: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue